export default "__VITE_ASSET__5e44b63a__"